export const tr = {
    'first-n-items-will-be-selected': {
        one: 'İlk {count} düzenleme seçilmek üzere',
        some: 'İlk {count} düzenleme seçilmek üzere',
        many: 'İlk {count} düzenleme seçilmek üzere',
        none: ''
    },
    'max-items-number-selected': 'Maksimum sayıda düzenleme seçildi',
    'more-than-max-items-number-selected': {
        one: 'Seçilebilecek maksimum düzenleme sayısı: {count}',
        some: 'Seçilebilecek maksimum düzenleme sayısı: {count}',
        many: 'Seçilebilecek maksimum düzenleme sayısı: {count}',
        none: ''
    },
    'no-results-text': 'Sorguyu kontrol edin veya kısaltmayı deneyin',
    'no-results-title': 'Sonuç bulunamadı'
};
